import { Component } from "@angular/core";

@Component({
    templateUrl:'./dummy.html'
})
export class DummyPageComponent {

}